import dayjs from 'dayjs';

/**
 *
 * 날짜 범위가 유효한지 체크하는 함수
 * @param date 날짜 범위
 * @param maxDateRange 최대 날짜 범위
 * @returns boolean, (true: 날짜 범위가 유효, false: 날짜 범위가 유효하지 않음)
 */
const isValidDateRange = (date: { start: Date; end: Date } | null, maxDateRange: number): boolean => {
  if (!date || !date.start || !date.end) {
    return false;
  }

  const dateDiff = dayjs(date?.end).diff(date?.start, 'day');
  const isDateLimitExceeded = dateDiff > maxDateRange;

  if (isDateLimitExceeded) {
    return false;
  }
  return true;
};

export default isValidDateRange;
